import Pino from "pino";

export const logger = Pino({
  formatters: {
    level: (label) => ({ level: label }),
  },
});
